import React from 'react';
import { useAppContext } from 'hooks/useAppContext';

const Overview = () => {
  const context = useAppContext();

  return (
  <div>Project Overview for project {context.selectedProject}</div>
  )
}

export default Overview;